module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f430.a8193176.svg";